import { useEffect, useState } from 'react';

import SearchWidget from './Search';
import LayerToggler from './LayerToggler';
import Sources from './Sources';

export default function SearchPanel({
  view,
  map,
  countyBorderLayer,
  countyBorderLayerView,
  activeLayer,
  activeLayerView,
}) {
  const [selectedLayer, setSelectedLayer] = useState('BlockGroups');

  function layerRadioChanged(e) {
    setSelectedLayer(e);
  }
  useEffect(() => {
    map.layers.forEach((layer) => {
      if (layer.id === selectedLayer) {
        layer.visible = true;
      } else {
        layer.visible = false;
      }
    });
  }, [selectedLayer, map.layers]);

  return (
    <div
      style={{
        backgroundColor: '#F2F2F2',
        boxShadow: '0 1px 2px rgb(0 0 0 / 30%)',
        width: '340px',
        padding: '5%',
      }}
    >
      <b>Area Median Income (AMI) tool</b>
      <div style={{ marginTop: '20px' }}>
        To get AMI info about an address or place in Maricopa County, select an
        address from the search bar.
      </div>
      <SearchWidget
        view={view}
        map={map}
        countyBorderLayer={countyBorderLayer}
        countyBorderLayerView={countyBorderLayerView}
        selectedLayer={selectedLayer}
      />
      <LayerToggler
        onChange={layerRadioChanged}
        selectedLayer={selectedLayer}
      />
      <Sources selectedLayer={selectedLayer} />
    </div>
  );
}
